export const ServerRoutes = {
    photos: "/api/photos"
}